export default "__VITE_ASSET__ByqwZyvF__"